import { Link } from "@tanstack/react-router";

import { teamMembers } from "@/data/team";

/**
 * Team cards matching the source layout: white rounded card, diamond-masked
 * portrait on the left, name / teaser / "Learn More" on the right.
 */
export function TeamGrid({ teasers }: { teasers?: Record<string, string> }) {
  return (
    <ul className="mt-12 grid gap-8 md:grid-cols-2">
      {teamMembers.map((member) => (
        <li
          key={member.slug}
          className="flex flex-col items-center gap-5 rounded-2xl bg-card p-5 text-center shadow-sm sm:flex-row sm:p-6 sm:text-left"
        >
          <img
            src={member.image}
            alt={member.name}
            loading="lazy"
            decoding="async"
            className="h-28 w-28 shrink-0 object-contain sm:h-32 sm:w-32"
          />
          <div className="min-w-0">
            <h3 className="text-2xl text-navy">
              <Link to="/team/$slug" params={{ slug: member.slug }} className="hover:text-brand">
                {member.name}
              </Link>
            </h3>
            {teasers?.[member.slug] ? (
              <p className="mt-2 text-base text-muted-foreground">{teasers[member.slug]}</p>
            ) : null}
            <Link
              to="/team/$slug"
              params={{ slug: member.slug }}
              className="mt-4 inline-flex items-center gap-1 font-sans text-base font-bold text-navy hover:text-brand"
            >
              Read {member.name}'s profile <span aria-hidden>↗</span>
            </Link>
          </div>
        </li>
      ))}
    </ul>
  );
}
